import uuid from "uuid";
import workspace from "../workspace";
import {attachResource} from "./resourseCanas";
import store from "../../../../../../store";
import {addSqftCroppedSlabImage} from "../../../../../../actions/sqftSlabFunctions";
import {MOVABLE_IMAGE_TYPES, SHAPE_PART_ID} from "../../../../constants";
import {initTitle} from "./labels/labelsHelper";
import {SLAB_IMAGE_TYPES} from "../../../../../../reducers/sqftSlabReducer";

const Duplicate = function () {
  this.cloneShape = (shape) => {
    let shapeData = shape.export();
    const workspaceIds = workspace.getObjIds();
    const newId = workspaceIds + 1;
    const currentShapePosition = shape.getPosition();

    const newShape = workspace.importShape(shapeData);
    newShape.setPosition({
      x: currentShapePosition.x + 10,
      y: currentShapePosition.y + 10,
    });
    newShape.shapeSlab.__absolutePos = null;
    newShape.shapePieces = [];
    newShape.setId(newId);
    workspace.setObjIds(newId);
    this.cloneShapeLines(newShape);
    if (newShape.partId === SHAPE_PART_ID.slabPlaceHolder) {
      newShape.init({
        x: currentShapePosition.x + 10,
        y: currentShapePosition.y + 10,
      });
      initTitle('PLACEHOLDER', SLAB_IMAGE_TYPES.placeholder, newShape);
    }
  }
  this.cloneShapeLines = (shape) => {
    const lines = shape.getLines();
    for (const line of lines) {
      this.cloneShapeLine(line);
    }
  }
  this.cloneShapeLine = (line) => {
    const attachedResource = workspace.getAttachedTo(line);
    line.id = uuid();
    line.from.id = uuid();
    if (attachedResource) {
      line.isDisabledInPopup = attachedResource.isDisabledInPopup;
      attachResource(line, null, attachedResource.type, attachedResource.featureId, null, attachedResource.name, attachedResource.height, uuid());
    }
  }

  this.cloneMovableImage = (shape) => {
    let imageData = shape.export();
    const workspaceIds = workspace.getObjIds();
    const newId = workspaceIds + 1;
    const currentMovableImagePosition = shape.getPosition();
    const movableImage = workspace.importImage(imageData);
    movableImage.setPosition({
      x: currentMovableImagePosition.x + 10,
      y: currentMovableImagePosition.y + 10,
    });
    movableImage.setId(newId);
    workspace.setObjIds(newId);

    if (movableImage.type === MOVABLE_IMAGE_TYPES.slabImage) {
      store.dispatch(addSqftCroppedSlabImage(movableImage));
    }
  }
}

export default new Duplicate()
